import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IButtonData } from 'src/app/dynamic-module/lib/public_api';

enum InfoState {
  opened = 'opened',
  closed = 'closed'
}

type AnimationState = InfoState.opened | InfoState.closed;

export interface ILicensePanelMappedItem {
  header?: string;
  subHeader?: string;
  price?: string;
  terms?: string;
  description?: SafeHtml;
  link?: IButtonData;
  linkColor?: string;
  informationArray?: {information: SafeHtml}[];
  modifierForCssClass?: string;
}

@Component({
  selector: 'license-card-item',
  templateUrl: './card-item.component.html',
  styleUrls: ['./card-item.component.less'],
  animations: [
    trigger('info', [
      state('opened', style({
        height: '*',
        opacity: '1',
      })),
      state('closed', style({
        height: '0',
        opacity: '0',
      })),
      transition('* => *', animate('.2s'))
    ]),
    trigger('arrow', [
      state('opened', style({
        transform: 'rotate(135deg)'
      })),
      state('closed', style({
        transform: 'rotate(-45deg)'
      })),
      transition('* => *', animate('.2s'))
    ])
  ]
})
export class CardItemComponent implements OnInit {
  @Input() data: ILicensePanelMappedItem;
  infoState: AnimationState = InfoState.closed;

  @ViewChild('content', {static: false}) contentRef: ElementRef;
  @ViewChild('description', {static: false}) descriptionRef: ElementRef;

  constructor() { }

  ngOnInit() {
  }

  toggleInfoState() {
    this.infoState === InfoState.closed ? this.infoState = InfoState.opened : this.infoState = InfoState.closed;
  }
}
